'use client';
import React from 'react';
import Link from 'next/link';
import AldarLogo from '@components/AldarLogo';
import cn from './style.module.scss';
export default function WildsLaunchFooter(props: any) {
  const { t } = props;
  return (
    <footer className={cn.wildsFooterWrapper}>
      <div className={cn.wildsFooterInner}>
        <div className={cn.wildsFooterInner__navigation}>
          <ul className={cn.wildsNavigationList}>
            <li>
              <Link href={props.links?.privacyPolicy} target="_blank" rel="noopener noreferrer">
                {t['footerPrivacy']}
              </Link>
            </li>
            <li>
              <Link href={props.links?.termsAndConditions} target="_blank" rel="noopener noreferrer">
                {t['footerCondition']}
              </Link>
            </li>
            <li>
              <Link href={props.links?.cookies} target="_blank" rel="noopener noreferrer">
                {t['footerCookies']}
              </Link>
            </li>
          </ul>
        </div>
        <div className={cn.wildsFooterInner__logo}>
          <Link
            className={cn.wildsLogoItem}
            href="https://www.aldar.com/properties/en"
            target="_blank" rel="noopener noreferrer"
          >
            <AldarLogo />
          </Link>
        </div>
      </div>
    </footer>
  );
}
